const numberFormatter = new Intl.NumberFormat('es-AR');

const currencyFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  maximumFractionDigits: 0,
});

export function formatNumber(value) {
  return numberFormatter.format(Number(value || 0));
}

export function formatCurrencyARS(value) {
  return currencyFormatter.format(Number(value || 0));
}

// Short money for tiles: $ 1,2 M / $ 850 k. Full value belongs in a tooltip.
export function formatCompactCurrency(value) {
  const amount = Number(value || 0);
  const abs = Math.abs(amount);
  if (abs >= 1_000_000) return `$ ${(amount / 1_000_000).toLocaleString('es-AR', { maximumFractionDigits: 1 })} M`;
  if (abs >= 10_000) return `$ ${Math.round(amount / 1_000).toLocaleString('es-AR')} k`;
  return formatCurrencyARS(amount);
}

export function formatDuration(minutes) {
  const total = Math.max(0, Math.round(Number(minutes || 0)));
  if (total < 60) return `${total} min`;
  const hours = Math.floor(total / 60);
  if (hours < 48) return `${hours} h ${total % 60} min`;
  return `${Math.floor(hours / 24)} d ${hours % 24} h`;
}

export function formatPercent(value, digits = 1) {
  return `${Number(value || 0).toLocaleString('es-AR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
}
